module.exports = __webpack_public_path__ + "img/volvo_xzmb.16d8027c.svg";